import React from 'react';
import { Tabs } from '../components/ui/Tabs';
import { SollecitiAutomationsTab } from '../components/automations/SollecitiAutomationsTab';
import { NotifichePreventiveTab } from '../components/automations/NotifichePreventiveTab';
export function Automazioni() {
  return <div className="space-y-6 pb-16" data-id="element-1767">
      <div data-id="element-1768">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-1769">Automazioni</h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-1770">
          Configura le regole automatiche per la gestione dei crediti e delle
          comunicazioni
        </p>
      </div>
      <Tabs tabs={[{
      id: 'solleciti',
      name: 'Solleciti',
      content: <SollecitiAutomationsTab data-id="element-1772" />
    }, {
      id: 'notifiche-preventive',
      name: 'Notifiche Preventive',
      content: <NotifichePreventiveTab data-id="element-1773" />
    }, {
      id: 'notifiche',
      name: 'Notifiche',
      content: <div className="p-4 text-gray-500" data-id="element-1774">
                Configurazione automazioni notifiche in sviluppo
              </div>
    }, {
      id: 'report',
      name: 'Report',
      content: <div className="p-4 text-gray-500" data-id="element-1775">
                Configurazione automazioni report in sviluppo
              </div>
    }]} data-id="element-1771" />
    </div>;
}